module.exports = __webpack_public_path__ + "img/UTULSP.2d3b3efc.png";